import liex from "../api/liex";
import appg from "../appg";

export const genericLoad = async (url, errorMessage, dataCallback) => {
  // console.log("en genericLoad: ", appg.getApiKey());
  try {
    const res = await liex.get(url);
    dataCallback(res.data);
  } catch (error) {
    dataCallback([]);
    if (error.response.data) {
      appg.toast.show({
        severity: "error",
        summary: errorMessage,
        detail: error.response.data.message,
      });
    }
  }
};

export const genericPost = async (url, errorMessage, payload, dataCallback) => {
  // console.log("en genericPost: ", appg.getApiKey());
  try {
    const res = await liex.post(url, payload);
    dataCallback(res.data);
  } catch (error) {
    // dataCallback(null);
    // console.log(" EL ERROR: ", error);
    if (error.response.data) {
      appg.toast.show({
        severity: "error",
        summary: errorMessage,
        detail: error.response.data.message,
      });
    }
  }
};
